import { render } from "./AnsweredQuestion.vue?vue&type=template&id=3b3a1287&scoped=true"
import script from "./AnsweredQuestion.vue?vue&type=script&lang=js"
export * from "./AnsweredQuestion.vue?vue&type=script&lang=js"

import "./AnsweredQuestion.vue?vue&type=style&index=0&id=3b3a1287&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b3a1287"]])

export default __exports__